'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Queue = /*#__PURE__*/function () {
  function Queue() {
    var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    _classCallCheck(this, Queue);
    this.maxSize = maxLength;
    this.array = [];
  }

  /**
   * @template T
   * @param {T} item
   */
  return _createClass(Queue, [{
    key: "push",
    value: function push(item) {
      // If we are out of room, get rid of the oldest element
      if (this.array.length >= this.maxSize) {
        this.array.pop();
      }
      this.array.unshift(item);
    }

    /**
     * @template T
     * @returns {T}
     */
  }, {
    key: "peek",
    value: function peek() {
      return this.array[0];
    }

    /**
     * @template T
     * @returns {T[]}
     */
  }, {
    key: "toArray",
    value: function toArray() {
      return this.array.slice();
    }
  }]);
}();
module.exports = Queue;
